import React from 'react';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, propagateProps } from '@philips-internal/oswald-ui-utils';
import { SuperscriptionItem } from '../superscription-item/superscription-item.js';
import { SuperscriptionProperties } from './superscription-types.js';
import './superscription.css';
const SuperscriptionContainer = {
    acceptedTypes: [
        ComponentType.DATA_DISPLAY,
    ],
    name: '',
};
function Superscription(props) {
    const { children, data = SuperscriptionProperties.data.defaultValue, showLabel, showTitle, titleExpression = SuperscriptionProperties.titleExpression.defaultValue, uuid = SuperscriptionProperties.uuid.defaultValue, } = props;
    const className = classNames({
        'c-superscription': true,
        [`${props.className}`]: Boolean(props.className),
    });
    const items = data.length
        ? data.map((item, index) => React.createElement(SuperscriptionItem, { key: index, showLabel: showLabel, ...item }))
        : propagateProps(children, { showLabel });
    return (React.createElement("div", { className: className },
        showTitle ? (React.createElement("div", { className: "c-superscription__title" }, MessageService.translate(titleExpression))) : null,
        React.createElement(Container, { acceptedTypes: SuperscriptionContainer.acceptedTypes, className: "c-superscription__items u-expand", uuid: uuid }, items)));
}
export { Superscription, SuperscriptionContainer, };
//# sourceMappingURL=superscription.js.map